<template>
    <div>
        <template v-if="planData && loadedProducts">
            <div class="border p-4">
                <b-row>
                    <b-col md="2">
                        <div>
                            <h6 class="mb-2 font-weight-bold">Shipment‘s number</h6>
                            <h4 class="mb-3">{{planData.uniqueNumber}}</h4>
                        </div>
                    </b-col>
                    <b-col md="2">
                        <h6 class="mb-2 font-weight-bold">Deliver</h6>
                        <div class="font-weight-bold">
                            {{planData.deliveryOrder.serviceId | capitalize}}
                        </div>
                    </b-col>
                    <b-col md="8" class="pt-1">
                        <b-btn variant="primary-user"
                            @click="printDocuments">
                            Print Documents
                        </b-btn>
                    </b-col>
                </b-row>
            </div>
            <div class="border p-4">
                <b-row>
                    <b-col md="4">
                        <b-row>
                            <b-col md="6">
                                <div class="address-box">
                                    <div class="address-box__title mb-2">
                                        <h6 class="font-weight-bold">Shipping Address:</h6>
                                    </div>
                                    <template v-if="planData && planData.address">
                                        <h6>{{address.fullName}}</h6>
                                        <h6>{{address.country.nameEn}}</h6>
                                        <h6>{{address.city}}, {{address.postalCode}}</h6>
                                        <h6>{{address.state}}</h6>
                                    </template>
                                </div>
                            </b-col>
                            <b-col md="6">
                                <h6 class="font-weight-bold">Ship To:</h6>
                                <p class="mb-0">
                                    Veiveriu 142, <br>
                                    Kaunas 46353 <br>
                                    Lithuania
                                </p>
                            </b-col>
                            <b-col md="12" class="mt-4">
                                <b-row v-if="summary">
                                    <b-col cols="auto">
                                        <b>{{planData.itemsTotalCount}} SKU</b>
                                    </b-col>
                                    <b-col cols="auto">
                                        <b>{{summary.totalPackeges}} total packages</b>
                                    </b-col>
                                    <b-col cols="auto">
                                        <b>{{summary.totalWeight}}kg total weight</b>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="8">
                        <h5 class="h6">Instructions</h5>
                        <b-row>
                            <b-col md="6">
                                <h6>Packing your Boxes</h6>
                                <ul>
                                    <li>Printed packing slips do not need to be placed in your boxes.</li>
                                    <li>For safety reasons, boxes containing more than one unit must not exceed 30 kg.</li>
                                    <li>A box containing one unit weighing over 30 kg. must be marked “Team Lift” on the top and sides.</li>
                                    <li>Use only approved packing material</li>
                                </ul>
                            </b-col>
                            <b-col md="6">
                                <h6>Labeling your boxes</h6>
                                <ul>
                                    <li>
                                        Print the full set of labels. Because each label is unique, do not photocopy, reuse,
                                        or modify labels for use on additional boxes.
                                    </li>
                                    <li>For each box, affix a shipping label and its accompanying carrier label.</li>
                                    <li>Place labels so they don't cover box seams.</li>
                                </ul>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
        </template>
        <div class="d-flex justify-content-center h-50 align-items-center" v-else>
            <b-spinner variant="info" style="width: 7rem; height: 7rem;"/>
        </div>
        <ShipmentPackagesTable :parcel="parcels" @loadedProducts="loadedProducts = true" />
        <div class="d-flex justify-content-end pt-4 pb-4" v-if="planData && loadedProducts">
            <b-btn variant="primary-user"
                    @click="createNewPlan">
                Create a new Shipping plan
            </b-btn>
            <b-btn variant="primary-user"
                    class="ml-2"
                    :to="{name: 'InventoryReplenishment'}">
                Open Replenishment shipments
            </b-btn>
        </div>
    </div>
</template>

<script>
    import {getPDF} from 'api/services'
    import ShipmentPackagesTable from './ShipmentPackagesTable'
    export default {
        name: 'ShipmentSummary',
        filters: {
            capitalize(value) {
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },
        components: {
            ShipmentPackagesTable
        },
        data() {
            return {
                planData: null,
                parcels: [],
                createdShipment: false,
                documentCreated: false,
                summary: null,
                loadedProducts: false
            }
        },
        computed: {
            address() {
                if (this.$route.params.planData) {
                    return this.$route.params.planData.address
                } else {
                    return this.planData.address
                }
            }
        },
        created() {
            if (!this.$route.params.planData) {
                this.getPlanData()
            }
            if (this.$route.params.planData) {
                this.planData = this.$route.params.planData
            }
            this.getPlanParcels()
        },
        methods: {
            getPlanData() {
                this.$api('GET', this.$endpoints.income(this.$route.params.planId)).then(response => {
                    this.planData = response
                })
            },
            getPlanParcels() {
                this.$api('GET', this.$endpoints.incomesParcels(this.$route.params.planId)).then(response => {
                    this.parcels = response
                    this.summary = {
                        // sku: response.reduce((previousValue, currentValue, index, array) => {
                        //     let sum = currentValue.parcelInventory.reduce((previousValue, currentValue, index, array) => {
                        //         return previousValue + currentValue.inventory.quantitySent
                        //     }, 0)
                        //     return previousValue + sum
                        // }, 0),
                        totalWeight: response.reduce((previousValue, currentValue, index, array) => {
                            return previousValue + currentValue.weight
                        }, 0),
                        totalPackeges: response.length
                    }
                })
            },
            printDocuments() {
                getPDF(this.$endpoints.printShipment(this.$route.params.planId), null, `shipment-${this.$route.params.planId}`)
                    .then()
                    .catch(() => {
                        this.$store.dispatch('globalAlertAction', {
                            type: 'error',
                            title: 'Error'
                        })
                        this.$store.commit('SET_LOADING', false)
                    })
            },
            createNewPlan() {
                this.$store.dispatch('createPlan').then(response => {
                    this.$router.push({
                        name: 'ReplenishmentAddProducts',
                        params: {
                            planId: response.id,
                            parent: 'plans',
                            parentBred: {
                                route: this.$route
                            }
                        },
                        query: {
                            planNumber: response.uniqueNumber || response.id
                        }
                    })
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    h4,
    .h4,
    h5,
    .h6 {
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/Replenishment/Shipment/ShipmentSummary.vue